/* Mitgelieferte Seitenvorlagen — Registry (Micha, Runde 230): nur noch Impressum, Notizseiten (liniert, kariert, punktiert wie bei Schreibblöcken) und eine schlichte Textseite.
   Alle weiteren Vorlagen entstehen aus dem Buch heraus („Als Vorlage speichern“ über jeder Seite oder per Rechtsklick) und gelten für alle Bücher. Jede mitgelieferte
   Vorlage ist eine Bauvorschrift für das aktuelle Blatt (Maße in mm innerhalb des Satzspiegels), Papiermuster sind dynamische Elemente. Reine Daten, kein DOM. */
import type { TplSpec } from './pagetpl-lib.ts';
import { IMPRINTS } from './tpl/imprint.ts';
import { NOTES } from './tpl/notes.ts';
import { TEXTPAGES } from './tpl/textpage.ts';
export type { TplCtx, TplSpec, TplFonts } from './pagetpl-lib.ts';

export const TPL_SPECS: TplSpec[] = [...IMPRINTS, ...NOTES, ...TEXTPAGES];
export const tplSpec = (id: string): TplSpec | undefined => TPL_SPECS.find(s => s.id === id);
export const tplSpecsOf = (cat: string): TplSpec[] => TPL_SPECS.filter(s => s.cat === cat);
